import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted, unref } from 'vue';
import { useResizeObserver } from '@/composables';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HorizontalScrollBox',
    setup(__props) {
        const isScrollStart = ref(false);
        const isScrollEnd = ref(false);
        const isScrollCenter = ref(false);
        const scrollBox = ref();
        // To detect when component is mounted, if scrollBox component overflow
        onMounted(() => {
            useResizeObserver(unref(scrollBox), (entries) => {
                const entry = entries[0];
                const { width } = entry.contentRect;
                if (width)
                    onResizeWindow(unref(scrollBox), width);
            });
        });
        // When user is scrolling, this detects the position of scroll
        const onScroll = function (e) {
            const { scrollLeft, offsetWidth, scrollWidth } = e.target;
            setBlurEffect(scrollLeft, offsetWidth, scrollWidth);
        };
        const onResizeWindow = function (e, width) {
            const { scrollLeft, offsetWidth, scrollWidth, clientWidth } = e;
            if (scrollWidth === width || offsetWidth === scrollWidth) {
                isScrollStart.value = false;
                isScrollCenter.value = false;
                isScrollEnd.value = false;
            }
            else {
                setBlurEffect(scrollLeft, offsetWidth, scrollWidth, clientWidth);
            }
        };
        const setBlurEffect = function (scrollLeft, offsetWidth, scrollWidth, clientWidth) {
            let scrollBarWidth;
            if (clientWidth) {
                scrollBarWidth = offsetWidth - clientWidth;
            }
            else {
                scrollBarWidth = 0;
            }
            if (scrollLeft === 0) {
                // When scroll is positioned at the start(left)
                isScrollStart.value = true;
                isScrollCenter.value = false;
            }
            else if (scrollLeft + offsetWidth < scrollWidth - scrollBarWidth) {
                // When scrolling is done in between start and end
                isScrollCenter.value = true;
                isScrollStart.value = false;
                isScrollEnd.value = false;
            }
            else if (scrollLeft + offsetWidth >= scrollWidth - scrollBarWidth) {
                // When scroll is positioned at the end(right)
                isScrollEnd.value = true;
                isScrollCenter.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "scrollBox",
                ref: scrollBox,
                class: _normalizeClass(["scrollbox-horizontal", {
                        'mask-right': isScrollStart.value,
                        'mask-left': isScrollEnd.value,
                        'mask-center': isScrollCenter.value
                    }]),
                "data-test-id": "scroll-box",
                onScroll: _cache[0] || (_cache[0] = ($event) => (onScroll($event)))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 34));
        };
    }
});
